module.exports = __webpack_public_path__ + "img/ECaravan64_ua.48fe9070.webp";